export const AbbreviateNumbersFilters = {

	/*
	**  Set up the filters
	*/

	filters: {

		toMillions: function(value) {

			return (value / 1000000).toFixed(2);

		},

		toThousands: function(value) {

			return (value / 1000).toFixed(2);

		},

		toMillionsRevenue: function(value) {

			let dollars = value / 100;

			return (dollars / 1000000).toFixed(2);

		},

		toThousandsRevenue: function(value) {

			let dollars = value / 100;

			return (dollars / 1000).toFixed(2);

		},

		twoDecimals: function(value) {

			let dollars = value / 100;

			return dollars.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

		},

		noDecimals: function(value) {

			let dollars = value / 100;

			return dollars.toFixed(0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

		},

	}
	
}